import { Component, Input, OnInit } from "@angular/core";
import { MasterPermission } from "../../models/masterpermission";
import { ApiService } from "./../../services/api";
import { OAuthService } from "app/services/o-auth";

@Component({
  selector: "app-permission",
  templateUrl: "./permission.component.html",
  styleUrls: ["./permission.component.scss"],
})
export class PermissionComponent implements OnInit {
  public Master: any;
  public users: Array<any>;
  @Input() userId: String;
  @Input() userType: any;
  @Input() isAdmin: boolean;
  @Input() cid: String;
  public selectedUser: any;
  public club;
  public loading: boolean = false;

  constructor(
    private apiService: ApiService,
    private oAuthService: OAuthService
  ) {
    this.club = this.oAuthService.getClub();
  }
  async ngOnInit() {
    this.loading = true;
    this.users = [];
    if (this.userId) {
      Promise.resolve(await this.setUpSingleUser(this.userId)).then(() => {
        this.loading = false;
      });
    } else if (this.cid) {
      await this.setUpMembers();
    } else {
      await this.setUpAllUserType();
    }
    this.onTabChange(0);
  }

  onTabChange(event) {
    if (this.users.length > 0)
      this.userChange(event, this.users[event].isAdmin);
  }
  async setUpMembers() {
    var memberId = this.club.cid ? this.club.cid : this.club.uid;

    this.apiService.list(`/club-members/${memberId}`).then(async (result) => {
      if (result) {
        console.log(result);

        for (let m = 0; m < result.length; m++) {
          const element = result[m];
          await this.setUpSingleUser(element.$key);
        }
        console.log(this.users);
        this.onTabChange(0);
        this.loading = false;
        return;
      }
    });
  }
  async setUpAllUserType() {
    this.users.push({
      name: "Club",
      value: 1,
      isSelected: true,
      isAdmin: true,
    });
    // this.users.push({ name: "Committee", value: 4, isSelected: false })
    // this.users.push({ name: "User", value: 2, isSelected: false })
    this.users.push({
      name: "Company",
      value: 5,
      isSelected: false,
      isAdmin: true,
    });
    this.users.push({
      name: "Society",
      value: 6,
      isSelected: false,
      isAdmin: true,
    });
    this.users.push({
      name: "Tour",
      value: 7,
      isSelected: false,
      isAdmin: true,
    });
    this.loading = false;
    return;
  }
  async setUpSingleUser(userId) {
    let user = await this.apiService.object("users/" + userId);
    let profile = await this.apiService.object(
      "user-profiles/" + userId + "/" + this.club.cid
    );
    console.log(user, profile, this.club.cid);
    if (this.club.uid != userId)
      this.users.push({
        name: user.fullName,
        value: profile.type,
        userId,
        isSelected: true,
        isAdmin: profile.role == 1 ? true : false,
      });
    console.log(this.users);
    if (this.users.length > 0) this.onTabChange(0);

    return;
  }
  public ReadSelect(event, item) {
    console.log(event, item);

    if (event) {
      item.read = true;
      if (item.children) {
        item.children.map((prem) => {
          prem.read = true;
          prem.create = true;
          prem.delete = true;
          prem.update = true;
        });
      }
    } else {
      item.read = false;
      item.create = false;
      item.delete = false;
      item.update = false;
      if (item.children) {
        item.children.map((prem) => {
          prem.read = false;
          prem.create = false;
          prem.delete = false;
          prem.update = false;
        });
      }
    }
    this.updateDatabase(item);
  }

  public CreateSelect(event, item) {
    if (event) {
      item.create = true;
    } else {
      item.create = false;
    }
    this.updateDatabase(item);
  }
  public UpdateSelect(event, item) {
    if (event) {
      item.update = true;
    } else {
      item.update = false;
    }
    this.updateDatabase(item);
  }
  public DeleteSelect(event, item) {
    if (event) {
      item.delete = true;
    } else {
      item.delete = false;
    }
    this.updateDatabase(item);
  }

  public async userChange(index, isAdmin) {
    for (let i = 0; i < this.users.length; i++) {
      this.users[i].isSelected = false;
    }
    if (this.users && this.users.length > 0) {
      this.users[index].isSelected = true;
      // assign user[index] into selectedUser
      this.selectedUser = this.users[index];
      this.selectedUser.index = index;

      this.Master = [];

      this.Master = JSON.parse(
        JSON.stringify(MasterPermission[this.selectedUser.value])
      );

      console.log("Master",this.Master)

      for (let i = 0; i < this.Master.length; i++) {
        this.Master[i].read = false;
        for (let p = 0; this.Master[i].children && p < this.Master[i].children.length; p++) {
          let master = this.Master[i].children[p];

          this.Master[i].children[p] = Object.assign(master, {
            read: false,
            create: false,
            delete: false,
            update: false,
          });

          // if (isAdmin) {

          //   this.Master[i].isread = false
          //   this.Master[i].children[p] = Object.assign(master, {
          //     isread: false,
          //     iscreate: false,
          //     isdelete: false,
          //     isupdate: false
          //   })
          // }
        }
      }
      let path = "";
      if (this.selectedUser.userId) {
        path =
          "user-permissions/" + this.selectedUser.userId + "/" + this.club.cid;
      } else {
        path = "master-permissions/" + this.selectedUser.value;
      }
      console.log(path);


      let permissions = await this.apiService.object(path);


      if (permissions.$exists()) {
        this.setUpPermissions(permissions);
      } else {
        if (this.selectedUser.userId) {
          let masterPer = await this.apiService.object(
            "master-permissions/" + this.selectedUser.value
          );
          this.setUpPermissions(masterPer);
          this.apiService.set(
            "user-permissions/" +
              this.selectedUser.userId +
              "/" +
              this.club.cid,
            masterPer
          );
        }
      }
    }
  }

  setUpPermissions(permissions) {
    for (let i = 0; i < this.Master.length; i++) {
      if (this.Master[i].id) {
        let Pperm = permissions[this.Master[i].id];
        if (Pperm)
          this.Master[i].read = Pperm.read != undefined ? Pperm.read : false;
      }

      for (let p = 0; this.Master[i].children && p < this.Master[i].children.length; p++) {
        let master = this.Master[i].children[p];
        let perm = permissions[master.id];
        if (perm) {
          this.Master[i].children[p] = Object.assign(master, {
            read: perm.read != undefined ? perm.read : false,
            create: perm.create != undefined ? perm.create : false,
            update: perm.update != undefined ? perm.update : false,
            delete: perm.delete != undefined ? perm.delete : false,
          });
        }
      }
    }
  }
  async updateDatabase(item) {
    let obj = {
      read: item.read == true ? true : null,
      create: item.create == true ? true : null,
      update: item.update == true ? true : null,
      delete: item.delete == true ? true : null,
      all: true,
    };
    let path = "";
    if (this.selectedUser.userId) {
      path =
        "user-permissions/" +
        this.selectedUser.userId +
        "/" +
        this.club.cid +
        "/" +
        item.id;
    } else {
      path = "master-permissions/" + this.selectedUser.value + "/" + item.id;
    }

    await this.apiService.set(path, obj);
    if (item.children && item.children.length > 0) {
      let update = {};
      item.children.map((x) => {
        let obj = {
          read: x.read == true ? true : null,
          create: x.create == true ? true : null,
          update: x.update == true ? true : null,
          delete: x.delete == true ? true : null,
          all: true,
        };
        update[
          `user-permissions/${this.selectedUser.userId}/${this.club.cid}/${x.id}`
        ] = obj;
      });

      await this.apiService.bulkUpdate(update);
    }
  }
}
